import { combineReducers } from 'redux';
import currentPBI from './currentPBI';
import currentWFS from './currentWFS';
import currentPurchaseConfirmation from './currentPurchaseConfirmation';

export default combineReducers({
  currentPBI,
  currentWFS,
  currentPurchaseConfirmation,
});
